import React, { FC, useEffect } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { setFooterHeight } from 'src/actions/appActions';
import { refreshUserInfo } from 'src/actions/authActions';
import { IRootReducers } from 'src/reducers';

interface OwnProps {
  icon?: string;
  title?: string;
  text?: string;
  buttonText?: string;
  ctaText?: string;
  ctaLink?: string;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ refreshUserInfo, setFooterHeight }, dispatch);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  OwnProps;

const ExperienceBlocked: FC<Props> = ({
  setFooterHeight,
  icon,
  title,
  text,
  ctaText,
  ctaLink,
}) => {
  useEffect(() => {
    setFooterHeight('hidden');
    return () => {
      setFooterHeight(null);
    };
  }, []);

  const iconClassnames = classNames(
    `icon icon--${icon} experience-blocked__icon`,
    {
      icon__increase_70: icon === 'address',
    }
  );

  return (
    <>
      <div className="experience-blocked__overlay" />
      <div className="experience-blocked__sticky">
        <div className="experience-blocked__content">
          <div className={iconClassnames} />
          <div className="experience-blocked__text">
            <h4 className="experience-blocked__title">{title}</h4>
            <p className="experience-blocked__description">{text}</p>
          </div>
        </div>
        <a href={ctaLink}>
          <span className="btn-line experience-blocked__link">{ctaText}</span>
        </a>
      </div>
    </>
  );
};

export default connect(null, mapDispatchToProps)(ExperienceBlocked);
